import { ContainersTable } from "@/components/Layout/Containers.table";
import { useStore } from "@/stores/useStore";
import { useMemo } from "react";
import { getIntegrationName } from "@/lib/integration";
import { isTechnicianWritebackEnabledForShop } from "@/lib/technicianWriteback";
import { getLinkableLabels } from "@/lib/getLinkableLabels";

export const ContainersPage = () => {
  const { employees, shop, cards } = useStore();

  const layouts = useMemo(() => shop?.layouts ?? [], [shop]);
  const labels = useMemo(() => (shop ? getLinkableLabels(shop) : []), [shop]);
  const containers = useMemo(() => shop?.containers ?? [], [shop]);

  return (
    <div className="overflow-auto p-4">
      <ContainersTable
        containers={containers}
        employees={employees ?? []}
        layouts={layouts}
        labels={labels}
        labelCatalog={shop?.labelCatalog}
        cards={cards}
        showCompletedHours={true}
        showCardCount={true}
        showTotalHours={true}
        showLinkedLayouts={false}
        integrationName={getIntegrationName(shop)}
        technicianWritebackEnabled={
          shop ? isTechnicianWritebackEnabledForShop(shop) : false
        }
      />
    </div>
  );
};
